<template>
  <w-icon-wrapper icon-name='work-add-icon'>
    <path
      id='Pfad_55661'
      d='M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z'
      data-name='Pfad 55661'
      fill='currentColor'
    />
    <path
      id='Pfad_55662'
      d='M17.657,11H13V6.343a1,1,0,0,0-2,0V11H6.343a1,1,0,0,0,0,2H11v4.657a1,1,0,0,0,2,0V13h4.657a1,1,0,0,0,0-2Z'
      data-name='Pfad 55662'
      fill='currentColor'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconAdd' };
</script>
